
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { logout } from "@/services/auth-service";

@Component
export default class Logout extends Vue {
  created() {
    logout();
  }
}
